import {
    CartSummarySwitcher,
    CartSummarySwitcherProps,
} from './CartSummarySwitcher';
export { CartSummarySwitcherProps };
export default CartSummarySwitcher;
